module.exports = __webpack_public_path__ + "img/ch29.f7a97837.jpg";